export const featureEnabled = (config, feature) => { var _a; return (_a = config.features) === null || _a === void 0 ? void 0 : _a[feature]; };
//# sourceMappingURL=utils.js.map